import {HubApiRequest} from '../hub-api-request';
import {HubMethod} from '../constants/methods';
import {v4 as uuidv4} from 'uuid';
import {GetPolicyReq, GetPolicyResponse} from '../protocol/get-policy-req';

export class GetPolicy extends HubApiRequest<GetPolicyReq, GetPolicyResponse> {
    constructor(url: string, deviceIdentifier: string, data: GetPolicyReq) {
        super(url, HubMethod.GET_POLICY, deviceIdentifier, data, uuidv4());
    }
}
